<template>
  <div>
    <table-manager @filterChanged="filterChanged" @paginationChanged="paginationChanged" :options="options" @ClickOnAddButton="showAdd"/>

    <basic-table
      v-if="NASlist"
      :items="NASlist"
      :fields="NASlistFields"
      @ClickOnDeleteButton="ClickOnDeleteButton"
      @ClickOnEditButton="editItem"
      :filter="filter"
      :perPage="perPage"
      :currentPage="currentPage"
      v-model="totalRows"
      isDelete="true"
      isEdit="true"/>
    <table-manager-bottom
      :totalRows="totalRows" :perPage="perPage"
      v-model="currentPage"/>
    <editModal :editItem="selectedNASlist"/>
  </div>
</template>

<script>
import editModal from './editModal'

export default {
  components: {
    editModal
  },
  data () {
    return {
      NASlistFields: [
        {key: 'nas_id', label: 'ID', sortable: true},
        {key: 'ip_address', label: 'NAS IP', sortable: true},
        {key: 'auth_secret', label: 'Auth secret', sortable: true},
        {key: 'acct_secret', label: 'Acc secret', sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ],
      options: {
        isShowAddButton: true
      },
      selectedNASlist: null,
      filter: null,
      perPage: 20,
      totalRows: 0,
      currentPage: 1
    }
  },
  methods: {
    showAdd () {
      this.selectedNASlist = {
        nas_id: 0,
        ip_address: '',
        auth_secret: '',
        acct_secret: '',
        dac_secret: '',
        das_port: '',
        isg_profile: 0,
        flags: 0,
        parameters: []
      }
      this.$root.$emit('bv::show::modal', 'modalEditNASlistSetting', '#btnShow')
    },
    editItem (item) {
      this.selectedNASlist = JSON.parse(JSON.stringify(item))
      this.$root.$emit('bv::show::modal', 'modalEditNASlistSetting', '#btnShow')
    },
    ClickOnDeleteButton (item) {
      this.$root.$emit('showConfirmation', 'Confirmation', this.$i18n.t('Are you sure you want to delete one of "NAS list"?'), this.deleteItem, item)
    },
    deleteItem (item) {
      let response = this.$store.dispatch('Settings/DELETE_NAS_LIST', item.nas_id)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'Settings/GET_NAS_LIST')
          this.$root.$emit('makeToasts')
        }
      })
    },
    filterChanged (value) {
      this.filter = value
    },
    paginationChanged (value) {
      this.perPage = value
    }
  },
  computed: {
    NASlist () {
      return this.$store.getters['Settings/NAS_LIST']
    }
  },
  mounted () {
    this.$store.dispatch('Settings/GET_NAS_LIST')
    this.$store.dispatch('Settings/GET_ISG_PROFILE')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/inventory/NASlist/main.vue